const roundNumber = ({ num, dp }: { num: number | string; dp: number }) => {
    // Covnert num to string, then string back to number to remove superfluous
    // digit chars added by toFixed. Return null if null or undefined.
    return num == null ? null : (+num).toFixed(dp);
};

export default roundNumber;
